
import useStateFromProps from "@/hooks/useStateFromProps";
import "./index.scss";

const TextSwitch = props => {
  const { 
    disabled = false,
    text1 = "开",
    text2 = "关",
    onChange,
  } = props;

  const [checked, setChecked] = useStateFromProps({
    value: props.checked,
    defaultValue: false,
  });

  const handleClick = () => {
    const value = !checked;
    setChecked(value);
    onChange?.(value, { setChecked });
  };

  return (
    <section
      className={`w-104px h-34px rounded-full transition duration-200 ease-in-out border-1px border-black border-opacity-10 relative bg-black bg-opacity-3 hover:bg-opacity-6 select-none ${disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'}`}
      onClick={
        () => {
          if(disabled){
            return;
          }
          handleClick();
        }
      }
    >
      <div
        className={`w-51px h-32px rounded-full bg-white transition-transform duration-200 ease-in-out transform-all absolute top-0 ${checked ? 'left-0' : 'left-1/2'}`}
      ></div>
      <div className="absolute w-full h-full top-0 left-0 flex items-center">
        <div className={`w-1/2 text-center ${checked ? 'font-bold' : ''}`}>
          {text1}
        </div>
        <div className={`w-1/2 text-center ${!checked ? 'font-bold' : ''}`}>
          {text2}
        </div>
      </div>
    </section>
  );
};

export default TextSwitch;
